var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgQrcode(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 130,
    viewBox: "0 0 130 130",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62.0019 0H55.6348V6.36709H62.0019V0Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M68.1835 0H61.8164V6.36709H68.1835V0Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M68.1835 6.18164H61.8164V12.5487H68.1835V6.18164Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M74.3652 6.18164H67.9981V12.5487H74.3652V6.18164Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M55.8203 12.3633H49.4532V18.7304H55.8203V12.3633Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M62.0019 12.3633H55.6348V18.7304H62.0019V12.3633Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M74.3652 12.3633H67.9981V18.7304H74.3652V12.3633Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M80.5468 12.3633H74.1797V18.7304H80.5468V12.3633Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M55.8203 18.5449H49.4532V24.912H55.8203V18.5449Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M74.3652 18.5449H67.9981V24.912H74.3652V18.5449Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M55.8203 24.7266H49.4532V31.0937H55.8203V24.7266Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M62.0019 24.7266H55.6348V31.0937H62.0019V24.7266Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M80.5468 24.7266H74.1797V31.0937H80.5468V24.7266Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M55.8203 30.9082H49.4532V37.2753H55.8203V30.9082Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M62.0019 30.9082H55.6348V37.2753H62.0019V30.9082Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M68.1835 30.9082H61.8164V37.2753H68.1835V30.9082Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M74.3652 30.9082H67.9981V37.2753H74.3652V30.9082Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M55.8203 37.0899H49.4532V43.457H55.8203V37.0899Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M68.1835 37.0899H61.8164V43.457H68.1835V37.0899Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M80.5468 37.0899H74.1797V43.457H80.5468V37.0899Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M55.8203 43.2715H49.4532V49.6386H55.8203V43.2715Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M62.0019 43.2715H55.6348V49.6386H62.0019V43.2715Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M68.1835 43.2715H61.8164V49.6386H68.1835V43.2715Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M6.36709 49.4532H0V55.8203H6.36709V49.4532Z",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7304 49.4532H12.3633V55.8203H18.7304V49.4532Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M24.912 49.4532H18.5449V55.8203H24.912V49.4532Z",
    fill: "white"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0937 49.4532H24.7266V55.8203H31.0937V49.4532Z",
    fill: "white"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2753 49.4532H30.9082V55.8203H37.2753V49.4532Z",
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M43.457 49.4532H37.0899V55.8203H43.457V49.4532Z",
    fill: "white"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M68.1835 49.4532H61.8164V55.8203H68.1835V49.4532Z",
    fill: "white"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M74.3652 49.4532H67.9981V55.8203H74.3652V49.4532Z",
    fill: "white"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M92.9101 49.4532H86.543V55.8203H92.9101V49.4532Z",
    fill: "white"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M99.0918 49.4532H92.7247V55.8203H99.0918V49.4532Z",
    fill: "white"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M105.273 49.4532H98.9063V55.8203H105.273V49.4532Z",
    fill: "white"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M111.455 49.4532H105.088V55.8203H111.455V49.4532Z",
    fill: "white"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M117.637 49.4532H111.27V55.8203H117.637V49.4532Z",
    fill: "white"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M24.912 55.6348H18.5449V62.0019H24.912V55.6348Z",
    fill: "white"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M68.1835 55.6348H61.8164V62.0019H68.1835V55.6348Z",
    fill: "white"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M74.3652 55.6348H67.9981V62.0019H74.3652V55.6348Z",
    fill: "white"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M80.5468 55.6348H74.1797V62.0019H80.5468V55.6348Z",
    fill: "white"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M86.7285 55.6348H80.3614V62.0019H86.7285V55.6348Z",
    fill: "white"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M92.9101 55.6348H86.543V62.0019H92.9101V55.6348Z",
    fill: "white"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M99.0918 55.6348H92.7247V62.0019H99.0918V55.6348Z",
    fill: "white"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M117.637 55.6348H111.27V62.0019H117.637V55.6348Z",
    fill: "white"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M6.36709 61.8164H0V68.1835H6.36709V61.8164Z",
    fill: "white"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7304 61.8164H12.3633V68.1835H18.7304V61.8164Z",
    fill: "white"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2753 61.8164H30.9082V68.1835H37.2753V61.8164Z",
    fill: "white"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M43.457 61.8164H37.0899V68.1835H43.457V61.8164Z",
    fill: "white"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6386 61.8164H43.2715V68.1835H49.6386V61.8164Z",
    fill: "white"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M62.0019 61.8164H55.6348V68.1835H62.0019V61.8164Z",
    fill: "white"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M80.5468 61.8164H74.1797V68.1835H80.5468V61.8164Z",
    fill: "white"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M92.9101 61.8164H86.543V68.1835H92.9101V61.8164Z",
    fill: "white"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M99.0918 61.8164H92.7247V68.1835H99.0918V61.8164Z",
    fill: "white"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M111.455 61.8164H105.088V68.1835H111.455V61.8164Z",
    fill: "white"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M117.637 61.8164H111.27V68.1835H117.637V61.8164Z",
    fill: "white"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M123.818 61.8164H117.451V68.1835H123.818V61.8164Z",
    fill: "white"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M130 61.8164H123.633V68.1835H130V61.8164Z",
    fill: "white"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7304 67.9981H12.3633V74.3652H18.7304V67.9981Z",
    fill: "white"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2753 67.9981H30.9082V74.3652H37.2753V67.9981Z",
    fill: "white"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6386 67.9981H43.2715V74.3652H49.6386V67.9981Z",
    fill: "white"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M62.0019 67.9981H55.6348V74.3652H62.0019V67.9981Z",
    fill: "white"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M74.3652 67.9981H67.9981V74.3652H74.3652V67.9981Z",
    fill: "white"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M80.5468 67.9981H74.1797V74.3652H80.5468V67.9981Z",
    fill: "white"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M86.7285 67.9981H80.3614V74.3652H86.7285V67.9981Z",
    fill: "white"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M92.9101 67.9981H86.543V74.3652H92.9101V67.9981Z",
    fill: "white"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M99.0918 67.9981H92.7247V74.3652H99.0918V67.9981Z",
    fill: "white"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M105.273 67.9981H98.9063V74.3652H105.273V67.9981Z",
    fill: "white"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M123.818 67.9981H117.451V74.3652H123.818V67.9981Z",
    fill: "white"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M130 67.9981H123.633V74.3652H130V67.9981Z",
    fill: "white"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M6.36709 74.1797H0V80.5468H6.36709V74.1797Z",
    fill: "white"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5487 74.1797H6.18164V80.5468H12.5487V74.1797Z",
    fill: "white"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7304 74.1797H12.3633V80.5468H18.7304V74.1797Z",
    fill: "white"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M24.912 74.1797H18.5449V80.5468H24.912V74.1797Z",
    fill: "white"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M43.457 74.1797H37.0899V80.5468H43.457V74.1797Z",
    fill: "white"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M55.8203 74.1797H49.4532V80.5468H55.8203V74.1797Z",
    fill: "white"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M62.0019 74.1797H55.6348V80.5468H62.0019V74.1797Z",
    fill: "white"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M80.5468 74.1797H74.1797V80.5468H80.5468V74.1797Z",
    fill: "white"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M99.0918 74.1797H92.7247V80.5468H99.0918V74.1797Z",
    fill: "white"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M111.455 74.1797H105.088V80.5468H111.455V74.1797Z",
    fill: "white"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M130 74.1797H123.633V80.5468H130V74.1797Z",
    fill: "white"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M55.8203 80.3614H49.4532V86.7285H55.8203V80.3614Z",
    fill: "white"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M62.0019 80.3614H55.6348V86.7285H62.0019V80.3614Z",
    fill: "white"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M80.5468 80.3614H74.1797V86.7285H80.5468V80.3614Z",
    fill: "white"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M111.455 80.3614H105.088V86.7285H111.455V80.3614Z",
    fill: "white"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M123.818 80.3614H117.451V86.7285H123.818V80.3614Z",
    fill: "white"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M62.0019 86.543H55.6348V92.9101H62.0019V86.543Z",
    fill: "white"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M68.1835 86.543H61.8164V92.9101H68.1835V86.543Z",
    fill: "white"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M74.3652 86.543H67.9981V92.9101H74.3652V86.543Z",
    fill: "white"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M86.7285 86.543H80.3614V92.9101H86.7285V86.543Z",
    fill: "white"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M105.273 86.543H98.9063V92.9101H105.273V86.543Z",
    fill: "white"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M111.455 86.543H105.088V92.9101H111.455V86.543Z",
    fill: "white"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M117.637 86.543H111.27V92.9101H117.637V86.543Z",
    fill: "white"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M55.8203 92.7247H49.4532V99.0918H55.8203V92.7247Z",
    fill: "white"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M99.0918 92.7247H92.7247V99.0918H99.0918V92.7247Z",
    fill: "white"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M105.273 92.7247H98.9063V99.0918H105.273V92.7247Z",
    fill: "white"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M55.8203 98.9063H49.4532V105.273H55.8203V98.9063Z",
    fill: "white"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M68.1835 98.9063H61.8164V105.273H68.1835V98.9063Z",
    fill: "white"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M74.3652 98.9063H67.9981V105.273H74.3652V98.9063Z",
    fill: "white"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M86.7285 98.9063H80.3614V105.273H86.7285V98.9063Z",
    fill: "white"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M99.0918 98.9063H92.7247V105.273H99.0918V98.9063Z",
    fill: "white"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M111.455 98.9063H105.088V105.273H111.455V98.9063Z",
    fill: "white"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M123.818 98.9063H117.451V105.273H123.818V98.9063Z",
    fill: "white"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M55.8203 105.088H49.4532V111.455H55.8203V105.088Z",
    fill: "white"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M74.3652 105.088H67.9981V111.455H74.3652V105.088Z",
    fill: "white"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M80.5468 105.088H74.1797V111.455H80.5468V105.088Z",
    fill: "white"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M86.7285 105.088H80.3614V111.455H86.7285V105.088Z",
    fill: "white"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M92.9101 105.088H86.543V111.455H92.9101V105.088Z",
    fill: "white"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M111.455 105.088H105.088V111.455H111.455V105.088Z",
    fill: "white"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M55.8203 111.27H49.4532V117.637H55.8203V111.27Z",
    fill: "white"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M80.5468 111.27H74.1797V117.637H80.5468V111.27Z",
    fill: "white"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M92.9101 111.27H86.543V117.637H92.9101V111.27Z",
    fill: "white"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M111.455 111.27H105.088V117.637H111.455V111.27Z",
    fill: "white"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M117.637 111.27H111.27V117.637H117.637V111.27Z",
    fill: "white"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M62.0019 117.451H55.6348V123.818H62.0019V117.451Z",
    fill: "white"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M74.3652 117.451H67.9981V123.818H74.3652V117.451Z",
    fill: "white"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M80.5468 117.451H74.1797V123.818H80.5468V117.451Z",
    fill: "white"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M86.7285 117.451H80.3614V123.818H86.7285V117.451Z",
    fill: "white"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M92.9101 117.451H86.543V123.818H92.9101V117.451Z",
    fill: "white"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M117.637 117.451H111.27V123.818H117.637V117.451Z",
    fill: "white"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M123.818 117.451H117.451V123.818H123.818V117.451Z",
    fill: "white"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M55.8203 123.633H49.4532V130H55.8203V123.633Z",
    fill: "white"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M80.5468 123.633H74.1797V130H80.5468V123.633Z",
    fill: "white"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M99.0918 123.633H92.7247V130H99.0918V123.633Z",
    fill: "white"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M105.273 123.633H98.9063V130H105.273V123.633Z",
    fill: "white"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M117.637 123.633H111.27V130H117.637V123.633Z",
    fill: "white"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0V43.2715H43.2715V0H0ZM37.0899 37.0899H6.18164V6.18164H37.0899V37.0899Z",
    fill: "white"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M86.543 0V43.2715H129.815V0H86.543ZM123.633 37.0899H92.7247V6.18164H123.633V37.0899Z",
    fill: "white"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M0 86.543V129.815H43.2715V86.543H0ZM37.0899 123.633H6.18164V92.7247H37.0899V123.633Z",
    fill: "white"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9082 12.3633H12.3633V30.9082H30.9082V12.3633Z",
    fill: "white"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M117.451 12.3633H98.9063V30.9082H117.451V12.3633Z",
    fill: "white"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9082 98.9063H12.3633V117.451H30.9082V98.9063Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrcode);
export default __webpack_public_path__ + "static/media/qrcode.20925a7c58069d0f8386d2e0c628a5e2.svg";
export { ForwardRef as ReactComponent };